import { createApp } from 'vue';
import ShareView from '../../../career/ShareView.vue'
const appElements = document.querySelectorAll('.vue-career-share-view')

Array.from(appElements).forEach(element => {
    createApp(ShareView).mount(element);
});